/**
 * @enum EnumUrl
 */
export enum EnumUrl {
  
    
    HOME = "/",
    REALTIME = "/real-times",
    REALTIME$ = "real-times",
    DELAYED = "/delayed",
    DELAYED$ = "delayed",
    DEMO = "/real-times-and-delayed",
  
}


// WEBPACK FOOTER //
// ./src/apps/enums/url/index.ts